export const SOCKET_TICKET_CHANNEL = 'CrmLevel::TicketChannel';
export const SOCKET_ACTIVE_TICKET_CHANNEL = 'CrmLevel::ActiveTicketChannel';
export const SOCKET_EMAIL_CHANNEL = 'CrmLevel::EmailChannel';
export const SOCKET_TICKET_LOG_CHANNEL = 'CrmLevel::TicketLogChannel';
export const SOCKET_MESSENGER_CHANNEL = 'CrmLevel::MessageChannel';
export const SOCKET_CHAIN_LIST_CHANNEL = 'CrmLevel::ChainClientChannel';
export const SOCKET_CHAIN_CHANNEL = 'CrmLevel::ChainChannel';
export const SOCKET_STATUS_CHANNEL = 'CrmLevel::ManagerChannel';
export const SOCKET_COMMON_CHANNEL = 'CrmLevel::CommonChannel';
export const SOCKET_TASK_CHANNEL = 'CrmLevel::TaskChannel';
export const SOCKET_ACTIVE_TASK_CHANNEL = 'CrmLevel::ActiveTaskChannel';
export const SOCKET_ACTIVE_TASK_COMMENT_CHANNEL =
  'CrmLevel::ActiveTaskCommentChannel';
export const SOCKET_NOTIFICATION_CHANNEL = 'CrmLevel::NotificationChannel';
